import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import WarningIcon from '@mui/icons-material/Warning';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import { Chip } from "@mui/material";

interface SituacaProcessoChipProps {
    situacao: string
}

export default function SituacaoExpedicaoChip({ situacao }: SituacaProcessoChipProps) {

    switch(situacao){
        case 'Receituário obrigatório': return (<Chip label="Receituário obrigatório" variant="outlined" color="error" icon={<WarningIcon />} />)
        case 'Aguardando expedição': return (<Chip label="Aguardando expedição" variant="outlined" color="warning" icon={<TimerOutlinedIcon />} />)
        case 'Concluido': return (<Chip label="Concluído" variant="outlined" color="primary" icon={<DoneOutlinedIcon />} />)
    }

    return <Chip label={situacao} variant="outlined" />
}